import axios from 'axios'
import API from './API.js'

export default class Edu_programs extends API {
  constructor() {
    super('edu_programs')
  }
  async getSemsterId(id) {
    try {
      const response = await axios.get(`/edu_programs/${id}/getSemsterId`)
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async MyEduPrograms() {
    try {
      const response = await axios.get('eduprograms/myeduprograms')
      console.log('model', response.data)
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async Details(id, params) {
    try {
      const response = await axios.get(`/edu_programs/details/${id}`, { params });
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async UnSubscribed(params) {
    try {
      const response = await axios.get('edu_program/notSubscribed_edu_programs', { params })
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }

  async subscribe(id) {
    const response = await axios.get(`/edu_programs/${id}/invoice`)
    return response.data
  }
  async subscribionFree(id) {
    const response = await axios.get(`/edu_programs/${id}/subscribionFree`)
    return response.data
  }
  async ProgramStatistics(id) {
    // const response = await axios.get(`/program_content/${id}`);
    return {}
  }
  async getCurrentEvents(id) {
    const response = await axios.get(`/eduprograms/getCurrentEvents/${id}`);
    return response.data.events;
  }
  async getFAQ(id) {
    const response = await axios.get(`/edu_program/faqs/${id}`);
    const data = [];
    response.data.forEach(element => {
      const item = data.find(a => a.id == element.type_id)
      console.log(item);
      if (item) {
        item.question.push(element);
      }
      else {
        data.push({ id: element.type_id, name: element.type, question: [element] })
      }
    });

    return data;
  }
  //get-courses-by-program
  async getCourseByProgram(id) {
    const response = await axios.get(`/get-courses-by-program/${id}`);
    return response.data;
  }
  async getCourseByProgramTeacher(id) {
    const response = await axios.get(`/get-courses-by-program-teacher/${id}`);
    return response.data;
  }
  async GetAllCourses(){
    const response = await axios.get(`/get-all-courses`);
    return response.data;
  }
    //get-courses-by-program
  async getExcelByProgram(id) {
    const response = await axios.get(`/get-excel-by-program/${id}`);
    return response.data;
  }
  async GetUsers(eduProgramId) {
    try {
      const response = await axios.get(`/edu_programs/${eduProgramId}/users`)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async GetTeachersCourses(eduProgramId) {
    try {
      const response = await axios.get(`/edu_programs/${eduProgramId}/getTeachersCourses`)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  ///edu_programs/{edu_program}/assign_official_exams
  async AssignOfficialExams(eduProgramId) {
    try {
      const response = await axios.get(`edu_programs/${eduProgramId}/assign_official_exams`)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  //
  async saveOfficialExams(edu_program, data, headers = {}) {
    try {
      const response = await axios.post(`/edu_programs/${edu_program}/save_official_exams`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  }
  ///edu_programs/{id}/subscribe
  async SubscribebyCode(data, headers = {}) {
    try {
      const response = await axios.post(`edu_programs/subscribe-by-code`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  }
  async SaveCourses(edu_program, data, headers = {}) {
    try {
      const response = await axios.post(`/edu_programs/${edu_program}/save_courses`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  }
  async AddEduProgramDetails(data, headers = {}) {
    try {
      const response = await axios.post(`/edu_programs/addEduProgramDetails`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  }
  async SaveTeachers(id, data, headers = {}) {
    try {
      const response = await axios.post(`/edu_programs/${id}/save_teachers`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }

  // /eduprograms/edu_program_approval'
  async EduProgramApproval(data) {
    try {
      const response = await axios.post(`/eduprograms/edu_program_approval`, data)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }

  async getEduCoursesOfFailedRoomsUsers(user_id){
    try {
      const response = await axios.get(`/edu_programs/getEduCoursesOfFailedRoomsUsers/${user_id}`);
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }
}
